module.exports = __webpack_public_path__ + "static/media/scanning_landcape.60ff09b5.gif";